import { Grid, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderRadius: '10px',
    background: 'white',
    margin: '20px 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '16px',
      margin: '10px 0',
    },
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  line: {
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 6,
    },
  },
  divider: {
    margin: '10px 0',
    width: '100%',
  },
}));

const StudentCardSkeleton = () => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.root}>
        <Skeleton variant="circle" width={80} height={80} style={{ backgroundColor: '#D6E7FF' }} className={classes.avatar} />
        <div className={classes.info}>
          <Skeleton variant="text" width="70%" height={28} style={{ backgroundColor: '#D6E7FF' }} className={classes.line} />
          <Skeleton variant="text" width="80%" height={20} style={{ backgroundColor: '#D6E7FF' }} className={classes.line} />
          <Skeleton variant="text" width="50%" height={20} style={{ backgroundColor: '#D6E7FF' }} className={classes.line} />
          <Skeleton variant="text" width="60%" height={20} style={{ backgroundColor: '#D6E7FF' }} className={classes.line} />
        </div>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
};

export default StudentCardSkeleton; 